import { defineComponent as n, openBlock as r, createBlock as a, unref as l, mergeProps as c, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconFlag",
  __name: "IconFlag",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (r(), a(l(i), c(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M5.75 4.822v7.348a6 6 0 0 1 .712-.208c1.296-.288 3.2-.26 5.817.786 2.051.82 3.485.715 4.42.405.828-.275 1.33-.731 1.551-.974V5.22a.4.4 0 0 0-.15-.042h-.01c-1.307.718-3.395 1.153-6.368-.036-3.57-1.428-5.393-.668-5.972-.319m12.327.355h.002-.002M5.75 13.822l.02-.012a3.5 3.5 0 0 1 1.018-.383c.954-.213 2.55-.24 4.934.714 2.337.935 4.137.87 5.448.436 1.298-.43 2.038-1.196 2.318-1.537a1.17 1.17 0 0 0 .262-.747V5.096c0-.685-.537-1.09-.905-1.255-.384-.172-.962-.267-1.459.01-.884.493-2.504.938-5.107-.103-4.422-1.769-6.78-.61-7.561-.04A1.16 1.16 0 0 0 4.25 4.651v15.793a.75.75 0 0 0 1.5 0v-6.622",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
